/**
 * Docebo specific course additional field mappings by number that give additional course meta data used by course detail
 */
export enum CourseAdditionalFields {
  TARGET_AUDIENCE = 8,
  COURSE_PRE_REQUISITES_SS = 9,
  COURSE_OBJECTIVES = 10,
  COURSE_OUTLINE = 11,
  SOFTWARE_VERSION_REQUIREMENT = 12,
  COURSE_DURATION_DAYS = 16, // Duration in Days (used for ILT/VILT courses)
  PRE_REQUISITESp = 24,
  EXTERNAL_COURSE_URL = 26,
  IS_FREE_COURSE = 27, // NOTE: Indicates a course is free without a subscription, if true. False requires subscription.
  ROLE = 29, // Administrator, Supervisor, Manager, etc...
  TOPIC = 30,
  COURSE_DURATION_MINS = 33, // Duration in Mins (used for eLearning courses)
  INSTRUCTION_TYPE = 36, // NOTE: There are different from the course learning type but in more detail specificity. Use this to see true learning type
}
